import { StrictMode, useEffect, useRef } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App.tsx";
import * as Sentry from "@sentry/react";

function sendHeight() {
  const height = document.documentElement.scrollHeight;
  window.parent.postMessage({ type: "setHeight", height }, "*");
}

Sentry.init({
  dsn: "https://ac51086de424cd0de3139b15fe33d0c6@o4509507566829568.ingest.de.sentry.io/4509507848896592",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ["localhost", "https://tamayouz-association.com"],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

function Root() {
  const observerRef = useRef<ResizeObserver>();

  useEffect(() => {
    // 1. Initial send
    sendHeight();

    // 2. Observe body for any size changes
    observerRef.current = new ResizeObserver(() => {
      sendHeight();
    });
    observerRef.current.observe(document.body);

    return () => observerRef.current?.disconnect();
  }, []);

  return (
    <StrictMode>
      <App />
    </StrictMode>
  );
}

createRoot(document.getElementById("root")!).render(<Root />);
